import { remove } from 'lodash-es';
import { IRightsType, USER_ADMIN } from '../types/enums';
import { isUS } from '../utils/config';
import { useUserStore } from './user';

export enum PermissionActionKey {
  CENTER_ACCOUNT_CHANGE_VERIFY_INFO = 'center_account_change_verify_info', // 账号管理-认证信息-变更认证信息
  UPGRADE_BENEFITS = 'upBenefits', // 升级权益按钮
  IDENTIFY = 'identify', // 主体认证
  TURN_IDENTIFY = 'turnIdentify', // 转授权认证
  COMPANY_VERIFY = 'company_verify', // 企业认证标识
  GO_COMPANY_VERIFY = 'go_company_verify', // 去认证
  RECENTLY_SHARE = 'recently_share', // 最近作品分享团员
  RECENTLY_PLAY = 'recently_play', // 最近作品-播放视频
  RECENTLY_COPY = 'recently_copy', // 最近作品-复制到团队空间

  COLLECTION_SHARE = 'collection_share', // 我的收藏 分享团员
  COLLECTION_PLAY = 'collection_play', // 我的收藏 播放音视频
  COLLECTION_SAVE = 'collection_save', // 我的收藏 另存新作品
  COLLECTION_TEMPLATE = 'collection_template', // 我的收藏 创建成片模板
  COLLECTION_USE_TEMPLATE = 'collection_use_template', // 我的收藏 创作同款

  PUBLISH_TO_YOUYAN_PLATFORM = 'publish_to_youyan_platform', // 发布到有言平台

  PERSONAL_SHARE = 'personal_share', // 个人空间分享
  PERSONAL_TEMP_SHARE = 'personal_temp_share', // 个人空间成片分享
  PERSONAL_COPY = 'personal_copy', // 个人空间复制到团队空间
  PERSONAL_SAVE = 'personal_save', // 个人空间 另存新作品
  PERSONAL_TEMPLATE = 'personal_template', // 个人空间 创建成片模板
  PERSONAL_USE_TEMPLATE = 'personal_use_template', // 个人空间 创作同款
  PERSONAL_RECOVERY = 'personal_recovery', // 个人空间 恢复
  PERSONAL_PUBLISH = 'personal_publish', // 个人空间 发布
  PERSONAL_UPLOAD = 'personal_upload', // 个人空间 上传
  PERSONAL_CUSTEMCOVER = 'personal_custem_cover', // 个人空间 自定义封面
  PERSONAL_PROMOTE = 'personal_promote', // 个人空间 推广

  TEAM_PAGE_SHOW = 'team_page_show', // 团队空间可见
  TEAM_RENAME = 'team_rename', // 团队空间重命名
  TEAM_DELETE = 'team_delete', // 团队空间删除
  TEAM_PUBLISH = 'team_publish', // 团队空间成片发布
  TEAM_UPLOAD = 'team_upload', // 团队空间 上传
  TEAM_COPY = 'team_copy', // 团队空间  复制到个人空间
  TEAM_SHARE = 'team_share', // 团队空间 分享
  TEAM_SAVE = 'team_save', // 团队空间  另存新作品并编辑
  TEAM_CREATE_PIECES_TEMPLATE = 'create_pieces_template', // 团队空间创建成片模板
  TEAM_BRAND_GUIDELINES = 'team_brand_guidelines', // 团队空间 设置/取消品牌规范
  TEAM_CUSTEMCOVER = 'team_custem_cover', // 团队空间 自定义封面
  TEAM_CANCEL_RENDER = 'team_cancel_render', // 团队空间 作品取消渲染(只有管理员可以操作)
  TEAM_OPUS_CLOSE = 'team_opus_close', // 团队空间 作品关闭(只有管理员可以操作)
  TEAM_OPUS_RETRY = 'team_opus_retry', // 团队空间 作品重新渲染(只有管理员可以操作)
  TEAM_CANCEL_QUEUE = 'team_cancel_queue', // 团队空间 成片取消排队(只有管理员可以操作)
  TEAM_RECYCLING_BIN = 'team_recycling_bin', // 团队空间 回收站(只有管理员可以操作)
  TEAM_PROMOTE = 'team_promote', // 团队空间 推广
  TEAM_CHARACTER_DELETE = 'team_character_delete', // 团队空间 删除角色(只有管理员可以操作)

  SHARE_CREATE_PIECES_TEMPLATE = 'share_create_pieces_template', // 与我分享- 创建成片模板 (只有管理员可以操作)
  SHARE_SAVE = 'share_save', // 与我分享- 另存新作品并编辑(只有管理员可以操作)

  BRAND_GUIDELINES = 'brand_guidelines', // 设置/取消品牌规范
  BRAND_RENAME = 'brand_rename', // 品牌重命名
  BRAND_FOLLOW = 'brand_follow', // 申请跟随与解除
  BRAND_SHARE = 'brand_share', // 品牌分享
  BRAND_PLAY = 'brand_play', // 品牌 - 播放
  BRAND_UPLOAD = 'brand_upload', // 品牌 - 上传
  TEMPLATE_SHARE = 'template_share', // 品牌 - 分享

  REDEMPTION_CODE = 'redemption_code', // 兑换码兑换
  STORAGE_BUY = 'storage_buy', // 加购存储空间
  COIN_BUY = 'coin_buy', // 加购言币
  SIDEBAR_GO_EQUITY = 'sidebar_go_equity', // 左下角点击进入权益管理
  NO_LIMITED_TIME = 'no_limited_time', // 无时间限制
  NO_CLONE_TIMES_SHOW = 'no_clone_times_show', // 无复制次数展示
  NO_SELECT_RIGHT = 'no_select_right', // 无权益筛选升级
  NO_NEW_YEAR_ACTIVITY_NOTICE = 'no_new_year_activity_notice', // 无新春活动弹窗
}

// 试用、个人
const PersonNumber = [IRightsType.TASTE, IRightsType.PERSONAL, IRightsType.PERSONAL_LITE];

// 企业版(标准、旗舰、入门、试用）
export const OrgAccount = [
  IRightsType.ORG_STANDARD,
  IRightsType.ORG_FLAGSHIP,
  IRightsType.TEAM_LIGHT,
  IRightsType.TEAM_TASTE,
];

// 对应版本权限
const MenuPermission: any = {
  // 体验版
  [IRightsType.TASTE]: [
    PermissionActionKey.UPGRADE_BENEFITS,
    PermissionActionKey.RECENTLY_PLAY,
    PermissionActionKey.PERSONAL_UPLOAD,
    PermissionActionKey.COLLECTION_PLAY,
    PermissionActionKey.COLLECTION_SAVE,
    PermissionActionKey.COLLECTION_TEMPLATE,
    PermissionActionKey.COLLECTION_USE_TEMPLATE,
    PermissionActionKey.PERSONAL_SAVE,
    PermissionActionKey.PERSONAL_TEMPLATE,
    PermissionActionKey.PERSONAL_USE_TEMPLATE,
    PermissionActionKey.PERSONAL_RECOVERY,
    PermissionActionKey.PERSONAL_PUBLISH,
    PermissionActionKey.PERSONAL_CUSTEMCOVER,
    PermissionActionKey.REDEMPTION_CODE,
    PermissionActionKey.PERSONAL_TEMP_SHARE,
    PermissionActionKey.SIDEBAR_GO_EQUITY,
    PermissionActionKey.PERSONAL_PROMOTE,
  ],
  // 个人版
  [IRightsType.PERSONAL_LITE]: [
    PermissionActionKey.UPGRADE_BENEFITS,
    PermissionActionKey.IDENTIFY,
    PermissionActionKey.RECENTLY_PLAY,
    PermissionActionKey.PERSONAL_UPLOAD,
    PermissionActionKey.COLLECTION_PLAY,
    PermissionActionKey.COLLECTION_SAVE,
    PermissionActionKey.COLLECTION_TEMPLATE,
    PermissionActionKey.COLLECTION_USE_TEMPLATE,
    PermissionActionKey.PERSONAL_SAVE,
    PermissionActionKey.PERSONAL_TEMPLATE,
    PermissionActionKey.PERSONAL_USE_TEMPLATE,
    PermissionActionKey.PERSONAL_RECOVERY,
    PermissionActionKey.PERSONAL_PUBLISH,
    PermissionActionKey.PERSONAL_CUSTEMCOVER,
    PermissionActionKey.PERSONAL_TEMP_SHARE,
    PermissionActionKey.REDEMPTION_CODE,
    PermissionActionKey.STORAGE_BUY,
    PermissionActionKey.COIN_BUY,
    PermissionActionKey.SIDEBAR_GO_EQUITY,
    // PermissionActionKey.NO_CLONE_TIMES_SHOW,
    PermissionActionKey.NO_LIMITED_TIME,
    PermissionActionKey.PERSONAL_PROMOTE,
  ],
  // 个人版
  [IRightsType.PERSONAL]: [
    PermissionActionKey.UPGRADE_BENEFITS,
    PermissionActionKey.IDENTIFY,
    PermissionActionKey.RECENTLY_PLAY,
    PermissionActionKey.PERSONAL_UPLOAD,
    PermissionActionKey.COLLECTION_PLAY,
    PermissionActionKey.COLLECTION_SAVE,
    PermissionActionKey.COLLECTION_TEMPLATE,
    PermissionActionKey.COLLECTION_USE_TEMPLATE,
    PermissionActionKey.PERSONAL_SAVE,
    PermissionActionKey.PERSONAL_TEMPLATE,
    PermissionActionKey.PERSONAL_USE_TEMPLATE,
    PermissionActionKey.PERSONAL_RECOVERY,
    PermissionActionKey.PERSONAL_PUBLISH,
    PermissionActionKey.PERSONAL_CUSTEMCOVER,
    PermissionActionKey.PERSONAL_TEMP_SHARE,
    PermissionActionKey.REDEMPTION_CODE,
    PermissionActionKey.STORAGE_BUY,
    PermissionActionKey.COIN_BUY,
    PermissionActionKey.SIDEBAR_GO_EQUITY,
    PermissionActionKey.NO_LIMITED_TIME,
    PermissionActionKey.PERSONAL_PROMOTE,
  ],
  // 企业-团员
  normal: [
    PermissionActionKey.RECENTLY_PLAY,
    PermissionActionKey.RECENTLY_SHARE,
    PermissionActionKey.RECENTLY_COPY,
    PermissionActionKey.COLLECTION_PLAY,
    PermissionActionKey.COLLECTION_SHARE,
    PermissionActionKey.COLLECTION_SAVE,
    PermissionActionKey.COLLECTION_TEMPLATE,
    PermissionActionKey.COLLECTION_USE_TEMPLATE,
    PermissionActionKey.PERSONAL_SHARE,
    PermissionActionKey.PERSONAL_COPY,
    PermissionActionKey.PERSONAL_SAVE,
    PermissionActionKey.PERSONAL_TEMPLATE,
    PermissionActionKey.PERSONAL_USE_TEMPLATE,
    PermissionActionKey.PERSONAL_RECOVERY,
    PermissionActionKey.PERSONAL_UPLOAD,
    PermissionActionKey.PERSONAL_PUBLISH,
    PermissionActionKey.TEAM_COPY,
    PermissionActionKey.TEAM_SAVE,
    PermissionActionKey.BRAND_SHARE,
    PermissionActionKey.BRAND_PLAY,
    PermissionActionKey.TEMPLATE_SHARE,
    PermissionActionKey.PERSONAL_TEMP_SHARE,
    PermissionActionKey.PERSONAL_CUSTEMCOVER,
    PermissionActionKey.COMPANY_VERIFY,
    PermissionActionKey.TEAM_PAGE_SHOW,
    PermissionActionKey.PERSONAL_PROMOTE,
    PermissionActionKey.TEAM_SHARE,
    PermissionActionKey.NO_LIMITED_TIME,
    PermissionActionKey.NO_SELECT_RIGHT,
    PermissionActionKey.NO_CLONE_TIMES_SHOW,
    PermissionActionKey.NO_NEW_YEAR_ACTIVITY_NOTICE,
  ],
  // 企业-超级管理员
  super: Object.values(PermissionActionKey).filter(
    item =>
      !item.includes(PermissionActionKey.REDEMPTION_CODE) &&
      !item.includes(PermissionActionKey.COIN_BUY),
  ),
};

// 对应过期版本权限
const OverTimePermission: any = {
  [IRightsType.PERSONAL_LITE]: [
    PermissionActionKey.UPGRADE_BENEFITS,
    PermissionActionKey.IDENTIFY,
    PermissionActionKey.RECENTLY_PLAY,
    PermissionActionKey.COLLECTION_PLAY,
    PermissionActionKey.PERSONAL_RECOVERY,
    PermissionActionKey.SIDEBAR_GO_EQUITY,
  ],
  // 体验版
  [IRightsType.TASTE]: [
    PermissionActionKey.UPGRADE_BENEFITS,
    PermissionActionKey.RECENTLY_PLAY,
    PermissionActionKey.COLLECTION_PLAY,
    PermissionActionKey.COLLECTION_SAVE,
    PermissionActionKey.COLLECTION_TEMPLATE,
    PermissionActionKey.COLLECTION_USE_TEMPLATE,
    PermissionActionKey.PERSONAL_RECOVERY,
    PermissionActionKey.SIDEBAR_GO_EQUITY,
  ],
  // 个人版
  [IRightsType.PERSONAL]: [
    PermissionActionKey.UPGRADE_BENEFITS,
    PermissionActionKey.IDENTIFY,
    PermissionActionKey.RECENTLY_PLAY,
    PermissionActionKey.COLLECTION_PLAY,
    PermissionActionKey.PERSONAL_RECOVERY,
    PermissionActionKey.SIDEBAR_GO_EQUITY,
  ],
  // 企业团员
  normal: [
    PermissionActionKey.RECENTLY_PLAY,
    PermissionActionKey.RECENTLY_SHARE,
    PermissionActionKey.COLLECTION_PLAY,
    PermissionActionKey.COLLECTION_SHARE,
    PermissionActionKey.BRAND_SHARE,
    PermissionActionKey.BRAND_PLAY,
    PermissionActionKey.TEMPLATE_SHARE,
    PermissionActionKey.PERSONAL_RECOVERY,
    PermissionActionKey.PERSONAL_SHARE,
    PermissionActionKey.COMPANY_VERIFY,
  ],
  // 企业超级管理员
  super: [
    PermissionActionKey.RECENTLY_PLAY,
    PermissionActionKey.RECENTLY_SHARE,
    PermissionActionKey.COLLECTION_PLAY,
    PermissionActionKey.COLLECTION_SHARE,
    PermissionActionKey.BRAND_SHARE,
    PermissionActionKey.BRAND_PLAY,
    PermissionActionKey.TEMPLATE_SHARE,
    PermissionActionKey.PERSONAL_RECOVERY,
    PermissionActionKey.PERSONAL_SHARE,
    PermissionActionKey.TEAM_SHARE,
    PermissionActionKey.TEAM_BRAND_GUIDELINES,
    PermissionActionKey.BRAND_GUIDELINES,
    PermissionActionKey.BRAND_RENAME,
    PermissionActionKey.BRAND_FOLLOW,
    PermissionActionKey.TEMPLATE_SHARE,
    PermissionActionKey.COMPANY_VERIFY,
    PermissionActionKey.GO_COMPANY_VERIFY,
    PermissionActionKey.SIDEBAR_GO_EQUITY,
  ],
};

// 页面按钮权限（通用权限）
export const checkPermission = (key: PermissionActionKey) => {
  const userInfo = useUserStore().user;

  if (!userInfo) {
    return false;
  }

  // 海外先把 言币/存够购买的入口都关闭
  if (isUS() && [PermissionActionKey.STORAGE_BUY].includes(key)) {
    return false;
  }

  // 是否过期对应操作列表
  const PermissionList = userInfo.is_expired ? OverTimePermission : MenuPermission;

  if (userInfo?.rights_type) {
    const rights = Number(userInfo?.rights_type);
    // 试用、个人
    if (PersonNumber.includes(rights)) {
      const rootList = PermissionList[rights];
      return rootList.includes(key);
    }

    // 企业版本权限
    if (OrgAccount.includes(rights)) {
      // 普通成员
      if (userInfo?.permission === USER_ADMIN.NORMAL) {
        return PermissionList.normal.includes(key);
      }
      // 企业管理员、超级管理员-最高权限
      const rights = PermissionList.super.slice(0);
      if (
        [IRightsType.ORG_STANDARD, IRightsType.ORG_FLAGSHIP].includes(userInfo.rights_type!) &&
        key === PermissionActionKey.UPGRADE_BENEFITS
      ) {
        return false;
      }

      if (userInfo?.rights_type === IRightsType.TEAM_LIGHT) {
        rights.push(PermissionActionKey.COIN_BUY);
      } //  团队入门版支持常显 key

      if (userInfo.rights_type === IRightsType.TEAM_TASTE) {
        rights.push(PermissionActionKey.UPGRADE_BENEFITS);
        remove(rights, v => v === PermissionActionKey.STORAGE_BUY);
      }

      return rights.includes(key);
    }
  }
};
